import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PaginationARComponent } from "./pagination-ar.component";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { FormsModule } from "@angular/forms";

@NgModule({
  imports: [CommonModule, FormsModule, PaginationModule.forRoot()],
  declarations: [PaginationARComponent],
  exports: [PaginationARComponent]
})
export class PaginationARModule {}
